'use strict';

/**
 *
 * @name: nnContributors
 *
 */

import _get from 'lodash.get'

import DirectiveTemplate from './nn-contributors.directive.html';
import './nn-contributors.directive.scss';

function NnContributorsDirective(apiUserService, memberAnalytics) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    transclude: true,
    template: DirectiveTemplate,
    link: function(scope, element) {

      /*
      *
      * @CONFIG
      *
      */

      scope.item = scope.content();
      scope.analytics = memberAnalytics;
      scope.settings = {
        totalPages: null
      };
      scope.swiperOptions = {
        spaceBetween: 30,
        on: {
          reachEnd: () => {
            scope.loadMore()
          }
        }
      }
      let order
      let page = 1;

      /*
      *
      * @PUBLIC
      *
      */

      scope.loadMore = function() {

        if (page < scope.settings.totalPages) {

          page++;

          apiUserService
            .listUsers(page, 8, ['contributor'], order)
            .then(function(res) {
              scope.item.contributors = scope.item.contributors.concat(res.data.items);
            });
        }
      };

      /*
      *
      * @PRIVATE
      *
      */

      function _terminate() {
        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      function _fetchData () {
        apiUserService
          .listUsers(1, 8, ['contributor'], order)
          .then(function(res) {

            if (res.data.items.length < 6) {

              _terminate();
            }

            scope.settings.totalPages = res.data.meta.totalPages;
            scope.item.contributors = res.data.items;
            scope.loaded = true;

          });
      }

      /*
      *
      * @INIT
      *
      */

      if ( !_get(scope, 'item.jsonData.sources[0].order[0]') ) {
        return _terminate();
      }

      order = scope.item.jsonData.sources[0].order[0];

      _fetchData()

      scope.$on('ngRepeatFinished', () => {
        scope.baseSwiper.setUpdate()
      })
    }
  };
}

export default NnContributorsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-contributors/nn-contributors.directive.js